import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-store-profile-space",
  templateUrl: "./store-profile-space.component.html",
  styleUrls: ["./store-profile-space.component.scss"]
})
export class StoreProfileSpaceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
